import React, { useState } from "react";

import { Link } from "react-router-dom";
import logo from "../../assets/images/redcrm.png";
import ProfileMenu from "./ProfileMenu";
import i18next, { t } from "i18next";
import arFlag from "../../assets/images/Flag-Egypt.png";
import enFlag from "../../assets/images/Flag-Britain.png";

const Header = (props) => {
  const [showInfo, setShowInfo] = useState(false);

  function toggleFullscreen() {
    if (
      !document.fullscreenElement &&
      /* alternative standard method */ !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      // current working methods
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        );
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  }

  function tToggle() {
    var body = document.body;
    if (window.screen.width <= 998) {
      body.classList.toggle("sidebar-enable");
    } else {
      body.classList.toggle("vertical-collpsed");
      body.classList.toggle("sidebar-enable");
    }
  }

  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box d-md-block">
              {/* <Link to="/home" className="logo logo-dark"> */}
              <span>
                <img src={logo} alt="" style={{ width: "50px" }} />
              </span>
              {/* </Link> */}
            </div>
          </div>
          <div className="d-flex" style={{ alignItems: "center", gap: "30px" }}>
            <ProfileMenu />

            {i18next.language === "en" ? (
              <a
                onClick={() => {
                  localStorage.setItem("lang", "en");
                  i18next.changeLanguage("en");
                }}
                style={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {/* <img
                  src={arFlag}
                  style={{ width: "20px", marginRight: "10px" }}
                />
                <span>{t("Arabic")}</span> */}
              </a>
            ) : (
              <a
                onClick={() => {
                  localStorage.setItem("lang", "en");
                  i18next.changeLanguage("en");
                }}
                style={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {/* <img
                  src={enFlag}
                  style={{ width: "20px", marginRight: "10px" }}
                />
                <span>{t("English")}</span> */}
              </a>
            )}

            <div className="dropdown d-none d-lg-inline-block ms-1">
              <button
                type="button"
                onClick={() => {
                  toggleFullscreen();
                }}
                className="btn header-item noti-icon "
                data-toggle="fullscreen"
              >
                <i className="bx bx-fullscreen" />
              </button>
            </div>
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

export default Header;
